'use client'

import { motion } from 'framer-motion'

interface FeatureCardProps {
  icon: React.ReactNode
  title: string
  description: string
  delay?: number
}

export function FeatureCard({
  icon,
  title,
  description,
  delay = 0,
}: FeatureCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="group relative overflow-hidden rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition-all hover:shadow-md dark:border-slate-800 dark:bg-slate-900"
    >
      <div className="bg-primary-100 text-primary-600 dark:bg-primary-900 dark:text-primary-400 mb-4 inline-flex rounded-lg p-3">
        {icon}
      </div>
      <h3 className="mb-2 text-xl font-semibold">{title}</h3>
      <p className="text-slate-600 dark:text-slate-400">{description}</p>
      <div className="from-primary-500 to-primary-600 absolute inset-0 bg-linear-to-r opacity-0 transition-opacity group-hover:opacity-5" />
    </motion.div>
  )
}
